// extracted by mini-css-extract-plugin
export default {"container":"Overlay_container__6j0vo"};